import React from "react";
import Grid from "@material-ui/core/Grid";
import { instance } from "Actions/AxiosInstance";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withSnackbar } from "notistack";
import Tooltip from "@material-ui/core/Tooltip";
import OrganizationChart from "@dabeng/react-orgchart";
import "./index.css";
import { getFormattedImageLink } from "Utils";
import PageHeader from "Component/Headers/pageHeader";
import buicon from "Assets/newicons/attribute/business-unit/outline/business-unit-outline-16px.svg";
import depicon from "Assets/newicons/attribute/department/outline/department-outline-16px.svg";
import desicon from "Assets/newicons/attribute/designation/outline/designation-outline-16px.svg";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { CheckActionPermission } from "Actions/commonAction";

const MyNode = ({ nodeData }) => (
  <div
    style={{
      padding: 4,
      height: 148,
      width: 148,
      position: "relative",
      boxSizing: "border-box",
    }}
  >
    <div className="avatar">
      {nodeData.id != "ff" ? (
        <a href={nodeData.link} target="_blank">
          <Tooltip title={nodeData.name} placement="top">
            <div className="display-flex" style={{ alignItems: "center" }}>
              <img
                style={{
                  height: 40,
                  width: 40,
                  marginRight: 8,
                  borderRadius: 40,
                }}
                src={getFormattedImageLink(nodeData.avatar)}
              />
              <div className="fullname ellipsis">{nodeData.name}</div>
            </div>
          </Tooltip>
        </a>
      ) : (
        <Tooltip title={nodeData.name} placement="top">
          <div
            className="display-flex"
            style={{
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div style={{ height: 100, width: 100, position: "relative" }}>
              <img
                style={{
                  maxHeight: 100,
                  maxWidth: 100,
                }}
                src={getFormattedImageLink(nodeData.avatar)}
                className="vertical-center"
              />
            </div>
            <div
              className="fullname ellipsis"
              style={{ marginTop: 12, textAlign: "center" }}
            >
              {nodeData.name}
            </div>
          </div>
        </Tooltip>
      )}
    </div>
    {/* <Tooltip title={nodeData.name} placement="top">
      <div className="fullname ellipsis">{nodeData.name}</div>
    </Tooltip> */}
    {nodeData.id != "ff" && nodeData.title && (
      <Tooltip title={nodeData.title} placement="top">
        <div className="position ellipsis">
          <img
            style={{
              height: 14,
              width: 14,
              marginRight: 4,
              verticalAlign: "middle",
            }}
            src={desicon}
          />
          {nodeData.title}
        </div>
      </Tooltip>
    )}
    {nodeData.id != "ff" && nodeData.department && (
      <Tooltip title={nodeData.department} placement="top">
        <div className="position ellipsis">
          <img
            style={{
              height: 14,
              width: 14,
              marginRight: 4,
              verticalAlign: "middle",
            }}
            src={depicon}
          />
          {nodeData.department}
        </div>
      </Tooltip>
    )}
    {nodeData.id != "ff" && nodeData.businessunit && (
      <Tooltip title={nodeData.businessunit} placement="top">
        <div className="position ellipsis">
          <img
            style={{
              height: 14,
              width: 14,
              marginRight: 4,
              verticalAlign: "middle",
            }}
            src={buicon}
          />
          {nodeData.businessunit}
        </div>
      </Tooltip>
    )}
    {nodeData.id != "ff" &&
      nodeData.children &&
      nodeData.children.length > 0 && (
        <div className="position-1">{`${nodeData.children.length} reports`}</div>
      )}
  </div>
);

class Reportee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportee: [],
    };
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("reportingHierarchy");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getReportees();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getReportees() {
    instance
      .get("subscription/reporteehierarchy")
      .then((response) => {
        const { subscriptionname, logo } = this.props.subscription;
        const getChildrens = (children) =>
          children
            ? children.map((emp) => ({
                id: emp.person.id,
                name: emp.person.name,
                title: emp.person.title,
                avatar: emp.person.avatar,
                link: emp.person.link,
                department: emp.person.department,
                businessunit: emp.person.businessunit,
                children: getChildrens(emp.children),
              }))
            : [];

        this.setState({
          reportee: {
            id: "ff",
            name: subscriptionname,
            title: "",
            avatar: logo,
            department: "",
            businessunit: "",
            children: response.data.result[0].data.map((emp) => ({
              id: emp.person.id,
              name: emp.person.name,
              title: emp.person.title,
              avatar: emp.person.avatar,
              link: emp.person.link,
              department: emp.person.department,
              businessunit: emp.person.businessunit,
              children: getChildrens(emp.children),
            })),
          },
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  render() {
    return (
      <IntlProvider locale="en" messages={""}>
        <main className="content-outer-wrapper">
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <Grid container className="position-rel">
              <Grid item xs={12} md={12} sm={12}>
                <PageHeader header={"Reporting hierarchy"} />
                {/* TODO: Remove the use of @dabeng/react-orgchart with an alternate implementation */}
                <OrganizationChart
                  datasource={this.state.reportee}
                  chartClass="myChart"
                  NodeTemplate={MyNode}
                />
              </Grid>
            </Grid>
          )}
        </main>
      </IntlProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    login: state.AuthenticationAction.login,
    subscription: state.SubscriptionInfo.SubscriptionData,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(Reportee));
